var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isBannerVisible
    ? _c("hero-banner", {
        attrs: {
          slides: _vm.mappedHeroBanners,
          "is-initialized": _vm.isInitialized,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }